import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE3_5 = () => (
  <Section>

    <UL>
      <LI>
        <P gapAfter>
          Für fortgeschrittene SuS: Anschließend können sich die SuS gegenseitig in einem <b>Expertenpuzzle</b> informieren, d. h. die Gruppen mischen sich so, dass mindestens je ein Experte (Soziale Aspekte/Ökologische Aspekte/Aspekte der Entsorgung) dabei ist und sich über die Recherche-Ergebnisse informieren kann.
        </P>
      </LI>
      <LI>
        <P gapBefore>
          Fassen Sie die Ergebnisse im Klassenverband in einem Tafelbild zusammen. Dazu können Sie folgendes Arbeitsblatt verwenden:
        </P>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3_5.js